export default __webpack_public_path__ + "static/media/pantalon-hombre.03a0b134.png";